export enum PracticeFocus {
    GP = 1,
    SpecER = 2,
    Equine = 3,
    Other = 4,
    UrgentCare = 5,
    ER = 6,
    Specialty = 7,
    Hybrid = 8,
    InHomeEuthanasia = 9,
}

export const PracticeFocusOptions: { [key: number]: string } = {
    [PracticeFocus.GP]: 'GP',
    [PracticeFocus.SpecER]: 'SpecER',
    [PracticeFocus.Equine]: 'Equine',
    [PracticeFocus.Other]: 'Other',
    [PracticeFocus.UrgentCare]: 'Urgent Care',
    [PracticeFocus.ER]: 'ER',
    [PracticeFocus.Specialty]: 'Specialty',
    [PracticeFocus.Hybrid]: 'Hybrid',
    [PracticeFocus.InHomeEuthanasia]: 'In-Home Euthanasia',
};

export const PracticeFocusOptionsShort: { [key: number]: string } = {
    [PracticeFocus.GP]: 'GP',
    [PracticeFocus.SpecER]: 'SP/ER',
    [PracticeFocus.Equine]: 'EQ',
    [PracticeFocus.Other]: 'OTHR',
    [PracticeFocus.UrgentCare]: 'UC',
    [PracticeFocus.ER]: 'ER',
    [PracticeFocus.Specialty]: 'SP',
    [PracticeFocus.Hybrid]: 'HY',
    [PracticeFocus.InHomeEuthanasia]: 'IHE',
};

export const PracticeFocusOptionsMapping = [
    {
        id: PracticeFocus.GP,
        label: PracticeFocusOptions[PracticeFocus.GP],
        fullName: 'General Practice',
        shortLabel: 'GP',
        mapMarker: '●',
    },
    {
        id: PracticeFocus.UrgentCare,
        label: PracticeFocusOptions[PracticeFocus.UrgentCare],
        fullName: PracticeFocusOptions[PracticeFocus.UrgentCare],
        shortLabel: 'UC',
        mapMarker: '⬟',
    },
    {
        id: PracticeFocus.ER,
        label: PracticeFocusOptions[PracticeFocus.ER],
        fullName: 'ER',
        shortLabel: 'ER',
        mapMarker: '⯃',
    },
    {
        id: PracticeFocus.Specialty,
        label: PracticeFocusOptions[PracticeFocus.Specialty],
        fullName: PracticeFocusOptions[PracticeFocus.Specialty],
        shortLabel: 'SP',
        mapMarker: '◆',
    },
    {
        id: PracticeFocus.SpecER,
        label: PracticeFocusOptions[PracticeFocus.SpecER],
        fullName: PracticeFocusOptions[PracticeFocus.SpecER],
        shortLabel: 'SP/ER',
        mapMarker: '■',
    },
    {
        id: PracticeFocus.Hybrid,
        label: PracticeFocusOptions[PracticeFocus.Hybrid],
        fullName: PracticeFocusOptions[PracticeFocus.Hybrid],
        shortLabel: 'HY',
        mapMarker: '▲',
    },
    {
        id: PracticeFocus.InHomeEuthanasia,
        label: PracticeFocusOptions[PracticeFocus.InHomeEuthanasia],
        fullName: PracticeFocusOptions[PracticeFocus.InHomeEuthanasia],
        shortLabel: 'IHE',
        mapMarker: '✶',
    },
    {
        id: PracticeFocus.Equine,
        label: PracticeFocusOptions[PracticeFocus.Equine],
        fullName: PracticeFocusOptions[PracticeFocus.Equine],
        shortLabel: 'EQ',
        mapMarker: '★',
    },
    {
        id: PracticeFocus.Other,
        label: PracticeFocusOptions[PracticeFocus.Other],
        fullName: PracticeFocusOptions[PracticeFocus.Other],
        shortLabel: 'OTHR',
        mapMarker: '🟆',
    },
];
